import { Button, ButtonProps } from 'antd';
import { ReactNode } from 'react';
import { SvgIcon } from '../svg-icon';
import { SvgIconName } from '../svg-icon/model';
import styles from './index.module.scss';

export const CommonButtonGroup = (props: {
  children: ReactNode;
  className?: string;
  gap?: number;
}) => {
  const { gap, ...otherProps } = props;
  return (
    <div
      {...otherProps}
      style={{ gap }}
      className={`${styles.btnGroup} ${props.className || ''}`}
    >
      {props.children}
    </div>
  );
};

export const MainButton = (props: ButtonProps & { iconButton?: boolean }) => {
  return (
    <Button
      {...props}
      className={`${styles.mainBtn} ${props.className || ''} ${
        props.iconButton && styles.iconButton
      }`}
      type="primary"
    >
      {props.children}
    </Button>
  );
};

export const CommonAddButton = (props: ButtonProps) => {
  return (
    <MainButton {...props} icon={<SvgIcon icon={SvgIconName.InviteAddIcon} />}>
      {props.children}
    </MainButton>
  );
};

export const CommonButton = (props: ButtonProps & { iconButton?: boolean }) => {
  if (props.type === 'link') {
    return (
      <Button
        {...props}
        className={`${styles.linkBtn} ${props.className || ''}`}
      >
        {props.children}
      </Button>
    );
  }
  return (
    <Button
      {...props}
      className={`${styles.commonBtn} ${props.className || ''}  ${
        props.iconButton && styles.iconButton
      }`}
    >
      {props.children}
    </Button>
  );
};

export const DangerButton = (props: ButtonProps & { iconButton?: boolean }) => {
  if (props.type === 'link') {
    return (
      <Button
        {...props}
        danger
        className={`${styles.linkBtn} ${props.className || ''} ${
          styles.dangerBtn
        }`}
      >
        {props.children}
      </Button>
    );
  }
  return (
    <Button
      {...props}
      danger
      className={`${styles.commonBtn} ${props.className || ''}  ${
        props.iconButton && styles.iconButton
      }  ${styles.dangerBtn}`}
    >
      {props.children}
    </Button>
  );
};

export const CancelButton = (props: ButtonProps) => {
  return (
    <CommonButton
      {...props}
      className={`${styles.cancelBtn} ${props.className || ''}`}
    >
      {props.children}
    </CommonButton>
  );
};

export const SubmitButton = (props: ButtonProps) => {
  return (
    <MainButton
      {...props}
      className={`${styles.submitBtn} ${props.className || ''}`}
    >
      {props.children}
    </MainButton>
  );
};
